import React from 'react';
import {Accordion} from 'react-bootstrap';
import {useDispatch} from 'react-redux';
import {toggleDisplaySideNav, toggleDisplayResults} from '../../redux/mobileDisplays';
import '../../styles/SideNav/SideNav.scss';
import Question from './Question';
import GetQuestionGrouping from '../../utils/QuestionGrouping';
import useMediaQuery from '../../hooks/useMediaQuery';
import BlackTriangle from '../../assets/images/black-triangle.svg';

function SideNav({currentQuestion, onChange, translations}) {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery('(max-width: 768px)');

  const hideSideNavOnMobile = () => {
    if (isMobile) {
      dispatch(toggleDisplaySideNav(false));
      dispatch(toggleDisplayResults(true));
    }
  };

  const QuestionGrouping = GetQuestionGrouping(translations);
  // console.log(QuestionGrouping);
  return (
    <section className="side-nav">
      <Accordion defaultActiveKey={QuestionGrouping[0]?.key}>
        {QuestionGrouping.map((qg, i) => {
          return (
            <Accordion.Item key={i} eventKey={qg.key}>
              <Accordion.Header className="bold diagonal-stripes d-flex flex-row align-items-center">
                <img src={BlackTriangle} className="toggle-icon" alt="toggle icon" />
                <div>{qg.title}</div>
              </Accordion.Header>
              <Accordion.Body className="p-0">
                <div onClick={hideSideNavOnMobile}>
                  <Question
                    items={qg.questions}
                    currentQuestion={currentQuestion}
                    onChange={onChange}
                    translations={translations}
                  />
                </div>
              </Accordion.Body>
            </Accordion.Item>
          );
        })}
      </Accordion>
    </section>
  );
}

export default SideNav;
